import { useEffect } from 'react'
import cooker from '../../utils/service/cooker'
import { getUtmParams, hasUtmParams } from '../../utils/helpers'

export default function useUtm(params) {
  useEffect(() => {
    if (hasUtmParams(params)) {
      cooker.set('conversion', JSON.stringify(getUtmParams(params)))
    } else {
      const conversion = cooker.get('conversion')
      if (!conversion) {
        if (document.referrer !== '') {
          cooker.set(
            'conversion',
            JSON.stringify({
              bt_referer: document.referrer,
            }),
          )
        } else {
          cooker.set(
            'conversion',
            JSON.stringify({
              utm_source: 'direct-traffic',
              utm_medium: 'bt-web',
            }),
          )
        }
      }
    }
  }, [params])
}
